module.exports = require('./helpers/bundle-url').getBundleURL('augD1') + "logo-dark.eefe0b7f.svg";